import { render } from "./AddEditTeam.vue?vue&type=template&id=7232dd7c&scoped=true"
import script from "./AddEditTeam.vue?vue&type=script&lang=js"
export * from "./AddEditTeam.vue?vue&type=script&lang=js"

import "./AddEditTeam.vue?vue&type=style&index=0&id=7232dd7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7232dd7c"]])

export default __exports__